import { ArrayObservable } from './ArrayObservable';
export var of = ArrayObservable.of;
//# sourceMappingURL=of.js.map